import All from "pages/Card/Register/All"
import Find from "pages/FindSection"
import Journal from "pages/Finance/Journal"
import { CreatePage } from "pages/Card/Transaction/CreateNewVendor/components"
import { CreatePage as CreateCustomer } from "pages/Card/Transaction/CreateNewCustomer/components"
import { CreatePage as CreateEmployee } from "pages/Card/Transaction/CreateNewEmployee/components"
import { CreatePageTwo as CreateEmployeeTwo } from "pages/Card/Transaction/CreateNewEmployee/components"
import { DetailPage as DetailVendor } from "pages/Card/Transaction/CreateNewVendor/components/ChildItem/components/Item/components"
import { DetailPage as DetailCustomer, UpdatePage as UpdateCustomer } from "pages/Card/Transaction/CreateNewCustomer/components/ChildItem/components/Item/components"
import { DetailPage as DetailEmployee, UpdatePage as UpdateEmployee } from "pages/Card/Transaction/CreateNewEmployee/components/ChildItem/components/Item/components"
import CreateShiftSchedule from "pages/Card/Transaction/ShiftSchedule/CreateShiftSchedule"
import type { RouteType } from "types"
import ApprovalShiftSchedule from "pages/Card/Transaction/ShiftSchedule/ApprovaShiftSchedule"
import { PERMISION } from "security"


export const cardsRoutes: RouteType[] = [
  {
    path: "/cards/register/all",
    element: <All />,
    permission: PERMISION.CARDS.REGISTER.PERMISION 
  },
  {
    path: "/cards/transaction/create-new-vendor",
    element: <CreatePage />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_VENDOR.CREATE
  },
  {
    path: "/cards/transaction/create-new-vendor/detail",
    element: <DetailVendor />,
    permission: PERMISION.CARDS.REGISTER.VENDOR.READ
  },

  {
    path: "/cards/transaction/create-new-customer",
    element: <CreateCustomer />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_CUSTOMER.CREATE
  },
  {
    path: "/cards/transaction/create-new-customer/create",
    element: <CreateCustomer />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_CUSTOMER.CREATE
  },
  {
    path: "/cards/transaction/create-new-customer/update",
    element: <UpdateCustomer />,
    permission: PERMISION.CARDS.REGISTER.CUSTOMER.UPDATE
  },
  {
    path: "/cards/transaction/create-new-customer/detail",
    element: <DetailCustomer />,
    permission: PERMISION.CARDS.REGISTER.CUSTOMER.READ
  },

  {
    path: "/cards/transaction/create-new-employee",
    element: <CreateEmployee />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_EMPLOYEE.CREATE
  },
  {
    path: "/cards/transaction/create-new-employees",
    element: <CreateEmployeeTwo />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_EMPLOYEE.CREATE
  },
  {
    path: "/cards/transaction/create-new-employee/create",
    element: <CreateEmployee />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_EMPLOYEE.CREATE
  },
  {
    path: "/cards/transaction/create-new-employee/update",
    element: <UpdateEmployee />,
    permission: PERMISION.CARDS.REGISTER.EMPLOYEE.UPDATE
  },
  {
    path: "/cards/transaction/create-new-employee/detail",
    element: <DetailEmployee />,
    permission: PERMISION.CARDS.REGISTER.EMPLOYEE.READ
  },
  {
    path: "/cards/transaction/create-shift-schedule/create",
    element: <CreateShiftSchedule />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_SHIFT_SCHEDULE.CREATE
  },
  {
    path: "/cards/transaction/approval-shift-schedule",
    element: <ApprovalShiftSchedule />,
    permission: PERMISION.CARDS.TRANSACTION.APPROVAL_SCHEDULE.READ
  },
  {
    path: "/cards/find",
    element: <Find />,
    permission: PERMISION.CARDS.FIND.PERMISION
  },
  {
    path: "/cards/journal",
    element: <Journal />,
    permission: PERMISION.CARDS.JOURNAL.PERMISION
  },
  {
    path: "/cards/transaction/create-new-investor",
    element: <div />,
    permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_INVESTOR.PERMISION/** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/cards/report/dashboard",
    element: <div />,
    permission: PERMISION.CARDS.REPORT.DASHBOARD.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/cards/report/card-list-summary",
    element: <div />,
    permission: PERMISION.CARDS.REPORT.CARD_LIST_SUMMARY.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/cards/report/card-list-detail",
    element: <div />,
    permission: PERMISION.CARDS.REPORT.CARD_LIST_DETAIL.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/cards/report/card-transaction",
    element: <div />,
    permission: PERMISION.CARDS.REPORT.CARD_TRANSACTION.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/cards/report/overdue-contact",
    element: <div />,
    permission: PERMISION.CARDS.REPORT.OVERDUE_CONTACT.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
]